/**
 * @author 陈韦润
 * @param
 * 组件描述，请详细说明
 */
export default function checkSpecified(target, keys) {
    if (!target) {
        return false;
    }
    for (const key of keys) {
        if (!target[key] || typeof target[key] !== 'function') {
            return false;
        }
    }
    return true;
}
